//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        name: 'maternal_form_b',
        data(){
            return{
                showSignature:false,
                form:{
                    room_number:'',
                    mom_name:'',
                    delivery_type:'',
                    cat_date:'',
                    number_of_meal:'',
                    eating_situation:'',
                    trait_common:'',
                    trait_special:'',
                    plan_carbohydrate:'',
                    plan_vegetables:'',
                    plan_fruits:'',
                    plan_meat:'',
                    plan_birds:'',
                    plan_fish:'',
                    plan_egg:'',
                    plan_bean_products:'',
                    plan_milk:'',
                    plan_dairy:'',
                    plan_oils:'',
                    plan_traditional_chinese_medicine:'',
                    shifts:''
                },
                option:{
                    penColor:"rgb(0, 0, 0)"
                },
            }
        },
        methods:{
            //请求用户基本信息
            apiMemberInfo(){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.checkRoomApi.memberInfo(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.form.delivery_type = res.data.birth_type == '1' ? '经阴道' : res.data.birth_type == '2' ? '剖宫产' : res.data.birth_type == '3' ? '小产' : ''
                        this.form.mom_name = res.data.name
                        this.form.room_number = res.data.room_name
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            // 保存
             save(){
                let signature ='signature1'
                console.info(this.$refs[signature])
                let png = this.$refs[signature].save()
                this.form.signature = encodeURI(png)
                this.showSignature = true
            },
            //编辑
            edit(){
                this.showSignature = false
            },
            //清除
            clear(){
                let signature ='signature1'
                let refs = this.$refs[signature].clear()
                this.form.signature = ''
            },
            //请求详情数据
            apiDetail(){
                let params = {
                    token: this.$cookie.get('token'),
                    id:this.$route.query.list_id
                }
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.bbFormApi.getMaternalMealRecordsFind(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        let data = res.data
                        this.form.room_number = data.room_number
                        this.form.mom_name = data.mom_name
                        this.form.delivery_type = data.delivery_type
                        this.form.cat_date = data.cat_date
                        this.form.number_of_meal = data.number_of_meal
                        this.form.eating_situation = data.eating_situation
                        this.form.trait_common = data.trait_common
                        this.form.trait_special = data.trait_special
                        this.form.plan_carbohydrate = data.plan_carbohydrate
                        this.form.plan_vegetables = data.plan_vegetables
                        this.form.plan_fruits = data.plan_fruits
                        this.form.plan_meat = data.plan_meat
                        this.form.plan_birds = data.plan_birds
                        this.form.plan_fish = data.plan_fish
                        this.form.plan_egg = data.plan_egg
                        this.form.plan_bean_products = data.plan_bean_products
                        this.form.plan_milk = data.plan_milk
                        this.form.plan_dairy = data.plan_dairy
                        this.form.plan_oils = data.plan_oils
                        this.form.plan_traditional_chinese_medicine = data.plan_traditional_chinese_medicine
                        this.form.shifts = data.shifts
                        this.showSignature = true
                        this.$vux.loading.hide()
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //请求添加数据
            apiAddForm(){
                let params = {
                    token: this.$cookie.get('token'),
                    number_id:this.$cookie.get('id'),
                    maternal_info_id: this.$route.query.id,
                    store_id:this.$cookie.get('store_id'),
                    room_number:this.form.room_number,
                    mom_name:this.form.mom_name,
                    delivery_type:this.form.delivery_type,
                    cat_date:this.form.cat_date,
                    number_of_meal:this.form.number_of_meal,
                    eating_situation:this.form.eating_situation,
                    trait_common:this.form.trait_common,
                    trait_special:this.form.trait_special,
                    plan_carbohydrate:this.form.plan_carbohydrate,
                    plan_vegetables:this.form.plan_vegetables,
                    plan_fruits:this.form.plan_fruits,
                    plan_meat:this.form.plan_meat,
                    plan_birds:this.form.plan_birds,
                    plan_fish:this.form.plan_fish,
                    plan_egg:this.form.plan_egg,
                    plan_bean_products:this.form.plan_bean_products,
                    plan_milk:this.form.plan_milk,
                    plan_dairy:this.form.plan_dairy,
                    plan_oils:this.form.plan_oils,
                    plan_traditional_chinese_medicine:this.form.plan_traditional_chinese_medicine,
                    shifts:this.form.shifts            
                }
                console.info(params)
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.bbFormApi.addMaternalMealRecordsData(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        this.$vux.loading.hide()
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:this.$route.query.form_id,
                                tabVal:this.$route.query.tabVal,
                                name : 'maternal_form_b',
                            }
                        })
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            // 请求更新数据
            apiUpdateForm(){
                let params = {
                    token: this.$cookie.get('token'),
                    id:this.$route.query.list_id,
                    number_id:this.$cookie.get('id'),
                    maternal_info_id: this.$route.query.id,
                    store_id:this.$cookie.get('store_id'),
                    room_number:this.form.room_number,
                    mom_name:this.form.mom_name,
                    delivery_type:this.form.delivery_type,
                    cat_date:this.form.cat_date,
                    number_of_meal:this.form.number_of_meal,
                    eating_situation:this.form.eating_situation,
                    trait_common:this.form.trait_common,
                    trait_special:this.form.trait_special,
                    plan_carbohydrate:this.form.plan_carbohydrate,
                    plan_vegetables:this.form.plan_vegetables,
                    plan_fruits:this.form.plan_fruits,
                    plan_meat:this.form.plan_meat,
                    plan_birds:this.form.plan_birds,
                    plan_fish:this.form.plan_fish,
                    plan_egg:this.form.plan_egg,
                    plan_bean_products:this.form.plan_bean_products,
                    plan_milk:this.form.plan_milk,
                    plan_dairy:this.form.plan_dairy,
                    plan_oils:this.form.plan_oils,
                    plan_traditional_chinese_medicine:this.form.plan_traditional_chinese_medicine,
                    shifts:this.form.shifts       
                }
                console.info(params)
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.bbFormApi.updateMaternalMealRecordsData(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        this.$vux.loading.hide()
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:this.$route.query.form_id,
                                tabVal:this.$route.query.tabVal,
                                name : 'maternal_form_b',
                            }
                        })
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            submitForm(){
                let form = this.form
                if(form.room_number == '' || form.mom_name == '' || form.delivery_type == '' || form.shifts == '' || form.cat_date == '' || form.number_of_meal == '' || form.eating_situation == '' || form.trait_common == '' || form.trait_special == '' || form.plan_carbohydrate == '' || form.plan_vegetables == '' || form.plan_fruits == '' || form.plan_meat == '' || form.plan_birds == '' || form.plan_fish == '' || form.plan_egg == '' || form.plan_bean_products == '' || form.plan_milk == '' || form.plan_dairy == '' || form.plan_oils == '' || form.plan_traditional_chinese_medicine == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请完善所有表单',
                    })
                    return
                }
                if(this.$route.query.list_id){
                    console.info("请求更新数据")
                    this.apiUpdateForm()
                }else{
                    console.info("请求添加数据")
                    this.apiAddForm()
                }
            }
        },
        created(){
            if(this.$route.query.list_id){
                this.apiDetail()
            }else{
                this.apiMemberInfo()
            }
        },
    }



// WEBPACK FOOTER //
// ./src/components/maternal_form_b.vue